export default __webpack_public_path__ + "static/media/leave-btn.cfba27fa.png";